import config from '../config';
import Transition from './Transition';

let apiManager;
let dataManager;
let soundManager;

class Intro extends Phaser.Scene {
  init () {
    let g = this;
    soundManager = g.scene.get('SoundManager');
    apiManager = g.sys.game.apiManager;
    dataManager = g.sys.game.dataManager;

    dataManager.setSessionItem(config.BASE_SCENE, 'Intro');

    g.sys.game.sdk.debug('Intro.init');
    // console.log('Intro.init');
  }

  create () {
    let g = this;
    // TODO: Hook up intro animations
    g.add.image(config.CENTER_X, config.CENTER_Y, 'intro-bg');
    g.add.image(config.CENTER_X, 180, 'game-logo');

    let benGlow = g.add.sprite(config.CENTER_X + 17, config.CENTER_Y + 108, 'intro');
    benGlow.setAlpha(0);

    let underGlow = g.add.sprite(config.CENTER_X + 60, config.CENTER_Y + 225, 'intro');
    underGlow.setVisible(false);

    let arm = g.add.sprite(config.CENTER_X - 67, config.CENTER_Y + 73, 'intro', 'arm/arm_05.png');

    let omni = g.add.sprite(config.CENTER_X + 135, config.CENTER_Y + 75, 'intro');
    omni.play('intro-omni');

    let burst = g.add.sprite(config.CENTER_X + 50, config.CENTER_Y + 215, 'intro');
    burst.setVisible(false);

    g.time.delayedCall(1000, () => {
      arm.play('intro-arm');
      g.time.delayedCall(250, () => {
        underGlow.play('intro-under-glow');
        burst.play('intro-burst');
        benGlow.play('intro-ben-glow');
        soundManager.playSound('watch-burst');
        g.tweens.add({
          targets: benGlow,
          alpha: 1,
          duration: 250
        });
      });
    });

    g.settingsButton = g.add.sprite(config.WIDTH - 10, 10, 'common', 'settings-button.png');
    g.settingsButton.setOrigin(1, 0);
    g.settingsButton.setInteractive();
    g.settingsButton.on('pointerdown', () => {
      g.scene.launch('SettingsPanel');
    });

    // add play button from the sprite sheet first frame
    // g.playButton = g.add.sprite(config.CENTER_X + 15, config.HEIGHT - 150, 'common', 'play-button.png');
    g.playButton = g.add.sprite(config.CENTER_X + 15, config.HEIGHT - 150, 'ui-animation');
    g.playButton.play('play-btn');
    g.playButton.setInteractive();
    g.playButton.once('pointerdown', () => {
      apiManager.trackGameStart();
      soundManager.playSound('play-btn');
      // soundManager.playSound('ben-play');
      this.transition.in(() => {
        g.scene.start('Play');
      });
    });

    if (dataManager.getHighScore() > 0) {
      g.add.sprite(config.CENTER_X + 18, 981, 'common', 'intro-best-label.png');
      let highScore = g.add.bitmapText(config.CENTER_X + 10, 1000, 'ocr30', dataManager.getHighScore().toLocaleString(), 24, 1);
      highScore.setOrigin(0.5);

      const subTextStyle = { fontFamily: g.game.localis.mainFont, fontSize: 24 +"px", color: "#000000" };
      const bestLabel = g.add.text(config.CENTER_X + 12, 966, g.game.localis.GetString("best"), subTextStyle);
      bestLabel.setOrigin(0.5);
    }

    soundManager.playMusic('loop-intro');

    apiManager.trackGameTitle();

    let transition = new Transition(g);
    transition.out();
    this.transition = transition;

    g.events.off('resume');
    g.events.on('resume', (a, data) => {
      // console.log('On Intro Resume');
      soundManager.resumeMusic();
    });
  }
}

export default Intro;
